import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class ProviderService {
  constructor(private _networkService: NetworkService) { }

  getplanList(query:any) {
    return this._networkService.get("api/provider?"+query, null, null, "bearer");
  }
  getplanListById(query) {
    return this._networkService.get("api/provider?" + query, null, null, "bearer");
  }
  saveplan(body: any) {
    return this._networkService.post("api/provider", body, null, "bearer");
  }
  Editplan(body: any) {
    return this._networkService.put("api/provider", body, null, "bearer");
  }

  deleteplan(id: any) {
    return this._networkService.delete("api/provider/" + id, null, "bearer")
  }
  getUserList(query:any) {

    return this._networkService.get("api/users/userList?"+query, null, null, "bearer");
  }
  getOrganizationsApi(query:any) {
    return this._networkService.get("api/organization?"+ query, null, null, "bearer");
  }
  getCodeApi(query:any) {
    return this._networkService.get("api/code/list?"+ query, null, null, "bearer");
  }
  addCode(body: any) {
    return this._networkService.post("api/code", body, null, "bearer");
  }
  editCode(body: any) {
    return this._networkService.put("api/code", body, null, "bearer");
  }

  deletecode(id: any) {
    return this._networkService.delete("api/code/delete/"+ id, null, "bearer")
  }
}
